import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section
      id="main-content"
      aria-label="אזור ראשי - Meet n' Meat פוד טראק בשרים"
      className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src="https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/68dfa9f2-e73a-439f-aa9a-5733a591bdd2_WhatsApp-Image-2026-04-09-at-18.37.50-9.jpeg?v=ea84c79ef8ab8c96b9df91ac8b6d87ca"
          alt=""
          role="presentation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full flex justify-start" dir="rtl">
        <div className="w-full md:w-[50%] lg:w-[45%] px-10 md:px-16 flex flex-col items-end text-right">
          <div
            className="inline-flex items-center gap-2 bg-[#e85d04]/20 border border-[#e85d04]/40 text-[#f4a261] px-4 py-2 rounded-full text-sm font-medium mb-6"
            style={{ fontFamily: "'Assistant', sans-serif" }}
            aria-hidden="true"
          >
            <i className="ri-fire-line" aria-hidden="true"></i>
            פוד טראק בשרים מקצועי
          </div>

          <h1
            className="text-white font-black leading-tight mb-6"
            style={{
              fontFamily: "'Assistant', sans-serif",
              fontSize: "clamp(2.2rem, 5vw, 4.5rem)",
              textShadow: "0 2px 20px rgba(0,0,0,0.5)"
            }}
          >
            בשרים מעושנים
            <br />
            <span className="text-[#e85d04]">שמגיעים אליכם</span>
          </h1>

          <p
            className="text-white/80 text-base md:text-lg max-w-sm mb-10 leading-relaxed"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            <span className="block">בשרים עשירים בטעמים אותנטיים וחוויית עישון ייחודית.</span>
            <span className="block">הכל נעשה בעבודת יד על מעשנת עץ אלון ודובדבן מובחר, בתהליך עישון איטי ומוקפד שמעניק לבשר עומק טעמים וארומה בלתי נשכחת.</span>
          </p>

          <div className="flex flex-row gap-4 items-center flex-wrap">
            <a
              href="#contact"
              className="bg-[#e85d04] hover:bg-[#d44d00] text-white px-7 py-3.5 rounded-full text-base font-bold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              הזמינו את העגלה לאירוע ←
            </a>
            <Link
              to="/menu"
              className="border-2 border-white/60 hover:border-white text-white px-7 py-3.5 rounded-full text-base font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Assistant', sans-serif" }}
            >
              לתפריט המלא
            </Link>
          </div>

          {/* Stats */}
          <div className="mt-14 flex gap-10" role="list" aria-label="נתוני פעילות">
            {[
              { num: "500+", label: "אירועים מוצלחים" },
              { num: "16", label: "שעות עישון ממוצע" },
              { num: "100%", label: "שביעות רצון" },
            ].map((stat) => (
              <div key={stat.label} className="text-center" role="listitem">
                <div
                  className="text-[#e85d04] font-black text-3xl md:text-4xl"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                  aria-label={`${stat.num} ${stat.label}`}
                >
                  {stat.num}
                </div>
                <div
                  className="text-white/70 text-xl md:text-2xl mt-1 whitespace-nowrap"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                  aria-hidden="true"
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 animate-bounce"
        aria-hidden="true"
      >
        <i className="ri-arrow-down-line text-2xl" aria-hidden="true"></i>
      </div>
    </section>
  );
};

export default Hero;
